module.exports = __webpack_public_path__ + "static/media/ecc-logo-round.cae02d72.png";